var TerminalSuggestCommandId;
( (function(TerminalSuggestCommandId) {
    TerminalSuggestCommandId["SelectPrevSuggestion"] = "workbench.action.terminal.selectPrevSuggestion";
    TerminalSuggestCommandId["SelectPrevPageSuggestion"] = "workbench.action.terminal.selectPrevPageSuggestion";
    TerminalSuggestCommandId["SelectNextSuggestion"] = "workbench.action.terminal.selectNextSuggestion";
    TerminalSuggestCommandId["SelectNextPageSuggestion"] = "workbench.action.terminal.selectNextPageSuggestion";
    TerminalSuggestCommandId["AcceptSelectedSuggestion"] = "workbench.action.terminal.acceptSelectedSuggestion";
    TerminalSuggestCommandId["AcceptSelectedSuggestionEnter"] = "workbench.action.terminal.acceptSelectedSuggestionEnter";
    TerminalSuggestCommandId["HideSuggestWidget"] = "workbench.action.terminal.hideSuggestWidget";
    TerminalSuggestCommandId["ClearSuggestCache"] = "workbench.action.terminal.clearSuggestCache";
})(TerminalSuggestCommandId || (TerminalSuggestCommandId = {})));
const defaultTerminalSuggestCommandsToSkipShell = [
    TerminalSuggestCommandId.SelectPrevSuggestion,
    TerminalSuggestCommandId.SelectPrevPageSuggestion,
    TerminalSuggestCommandId.SelectNextSuggestion,
    TerminalSuggestCommandId.SelectNextPageSuggestion,
    TerminalSuggestCommandId.AcceptSelectedSuggestion,
    TerminalSuggestCommandId.AcceptSelectedSuggestionEnter,
    TerminalSuggestCommandId.HideSuggestWidget,
    TerminalSuggestCommandId.ClearSuggestCache,
];
export { TerminalSuggestCommandId, defaultTerminalSuggestCommandsToSkipShell };
